import { FC } from "react";

import { Stack } from "@mui/material";

import { useCampaignLifeCycleChoiceContext } from "../Context/CampaignLifeCycleChoiceContext";

import Image from "@/components/Image/Image";

export const Illustration: FC = () => {
  const { replacesTicketingId } = useCampaignLifeCycleChoiceContext();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={(theme) => ({ height: "100%", backgroundColor: theme.palette.surface.neutral.supershy })}
    >
      {replacesTicketingId ? (
        <Image alt="" src="/images/membership-campaign-life-cycle/replace-campaign.svg" width={414} height={360} />
      ) : (
        <Image alt="" src="/images/membership-campaign-life-cycle/brand-new-program.svg" width={414} height={414} />
      )}
    </Stack>
  );
};
